import React, { useState, useContext, useEffect } from 'react'
import { Container, Grid, Divider, TextField, InputAdornment, IconButton } from '@material-ui/core'
import { SkyPaper } from '../Core/Frames/SkyPaper'
import { ReactComponent as AccountSvg } from '../../assets/sidemenu/login.svg'
import { ReactComponent as ErrorDocument } from '../../assets/error_document.svg'
import './BrokerPortal.scss'
import FlexView from 'react-flexview/lib'
import { GetEmailPopup } from './Common/GetEmailPopup'
import { AddMotorcyclesPopup } from './Common/AddMotorcyclePopup'
import { SessionContextStore } from '../../context/SessionContext'
import { useHistory } from 'react-router-dom'
import { EventEmitterService, EventKey } from '../../services/EventEmitterService'
import { FirebaseService, FirebaseConfigKey } from '../../services/FirebaseService'
import EqualizerIcon from '@material-ui/icons/Equalizer'
import ShareIcon from '@material-ui/icons/Share'
import brokerApi from '../../api/broker.api'
import { awaitWithLoading, generateProposalLink } from '../../services/utils'
import { ElevatedCircle } from '../Core/ElevatedCircle'
import { CopyToClipboard } from '../Core/Buttons/CopyToClipboardButton'
import { SessionService } from '../../services/SessionService'
import BrokerConfigService from '../../services/BrokerConfigService'
import { MotocyclesApi } from '../../api/motorcycles.api'
import { GlobalTextField } from '../Core/Input/ControlledTextField'
import adminApi from '../../api/admin.api'
import { ACTIONS, UserProfileContextStore } from '../../context/UserProfileContext'
import { Action } from '../../models/Action'
import { CustomErrorPopup } from '../PopUps/CustomErrorPopup'
import { AuthApi } from '../../api/auth.api'
import ComingSoon from '../../assets/coming_soon.png'
import classNames from 'classnames'
import { GetImpersonationPopup } from './Common/GetImpersonationPopup'

export const BrokerPortalPanel = () => {
  const [popup, setPopup] = useState({ open: false, title: '', body: '', action: '', showDuration: false })
  const [emailPopup, setEmailPopup] = useState({ open: false, title: '', body: '', action: '', showDuration: false })
  const [motorcyclePopup, setMotorcyclePopup] = useState({ open: false, title: '', body: '', action: '', showDuration: false })
  const sessionContext = useContext(SessionContextStore)
  const profileContext = useContext(UserProfileContextStore)
  const [popUpErrorState, setPopUpErrorState] = React.useState({
    title: '',
    body: '',
    showPopUp: false,
  })

  const history = useHistory()

  const onConfirmMotorcycle = async data => {
    let res = await awaitWithLoading(MotocyclesApi.addNewMotorcycle(data))
    if (res.ok) {
      cancelMotorcyclePopup()
    }
  }
  const onConfirm = async data => {
    if (popup.action == 'proposalProfile' || emailPopup.action == 'proposalProfile') {
      let res = await awaitWithLoading(brokerApi.generateProposalToken(data.email))
      if (res.ok) {
        cancelPopup()
        EventEmitterService.dispatch(EventKey.ShowSuccess, {
          title: 'Proposal Link',
          icon: (
            <ElevatedCircle>
              {' '}
              <ShareIcon className="blue" />
            </ElevatedCircle>
          ),
          body: (
            <>
              <div className="margin-bottom-small">Copy and paste the link below to the email you send to your client</div>
              <GlobalTextField
                InputProps={{
                  endAdornment: (
                    <InputAdornment>
                      {' '}
                      <CopyToClipboard text={generateProposalLink(res.data.proposal_form_token)} />{' '}
                    </InputAdornment>
                  ),
                }}
                fullWidth
                disabled={true}
                value={generateProposalLink(res.data.proposal_form_token)}
              />
            </>
          ),
        })
      } else EventEmitterService.dispatch(EventKey.ShowError, res)
    } else if (popup.action == 'mvr' || emailPopup.action == 'mvr') {
      EventEmitterService.dispatch(EventKey.ShowLoader)
      let res = await AuthApi.checkIfUserExist(data.email)
      if (res.ok) {
        if (res.data.is_user_exist) {
          history.push(`/broker/admin/userMvrRecord/${res.data.user_profile_id}`)
          EventEmitterService.dispatch(EventKey.DismissLoader)
        } else {
          setPopUpErrorState({
            title: 'Oops!',
            body: res.data.message,
            showPopUp: true,
          })
          EventEmitterService.dispatch(EventKey.DismissLoader)
        }
      } else {
        EventEmitterService.dispatch(EventKey.DismissLoader)
        EventEmitterService.dispatch(EventKey.ShowError, res)
      }
    } else {
      let res = await sessionContext.bindUserForBroker(data.email, data.action)
      if (res.ok) {
        EventEmitterService.dispatch(EventKey.USER_LOGGED_IN)
        if (popup.action == 'policyManagement' || emailPopup.action == 'policyManagement') {
          history.push('/policy-management')
        } else if (popup.action == 'account' || emailPopup.action == 'account') {
          history.push('/account')
        } else if (popup.action == 'discounts' || emailPopup.action == 'discounts') {
          history.push('/discounts')
        } else if (popup.action == 'fileAClaim' || emailPopup.action == 'fileAClaim') {
          history.push('/claim')
        }
        // else if(data.action == 'monthlyBind') {
        //     history.push('/insurance/monthly')
        // }
        else if (data.action == 'annualBind') {
          history.push('/insurance/profile')
        }
      } else EventEmitterService.dispatch(EventKey.ShowError, res)
    }
  }

  const cancelPopup = () => {
    setPopup({ open: false, title: '', body: '', action: '' })
    setEmailPopup({ open: false, title: '', body: '', action: '' })
  }
  const cancelErrorPopup = () => setPopUpErrorState({ open: false, title: '', body: '' })
  const openDashboard = () => window.open(process.env.REACT_APP_DASHBOARD_URL, '_blank')
  const gotoAccounts = () => history.push({ pathname: '/broker/accounts/active' })
  const gotoRecentSubmissions = () => history.push({ pathname: '/broker/accounts/recent' })
  const gotoPolicyManagement = () =>
    setPopup({ open: true, title: "Manage Insured's Policies", body: 'Search By', action: 'policyManagement' })
  const addMotorcycle = () =>
    setMotorcyclePopup({ open: true, title: 'Add Motorcycle To DB', body: 'Insert motorcycle data', action: 'addMotorcycle' })
  const cancelMotorcyclePopup = () => setMotorcyclePopup({ open: false, title: '', body: '', action: '' })
  const gotoDiscountManagement = () =>
    setPopup({ open: true, title: "Manage Insured's Discounts", body: "Insert the insured's email", action: 'discounts' })
  const gotoInsuredAccount = () => setPopup({ open: true, title: "Manage Insured's Account", body: 'Search By', action: 'account' })
  const shareProporsalLink = () =>
    setPopup({ open: true, title: 'Share Proposal Link', body: "Insert the insured's email", action: 'proposalProfile' })
  const bindAnnualPolicy = () =>
    setEmailPopup({
      open: true,
      title: 'Quote / Bind Coverage',
      body: "Insert the insured's email",
      duration: 'annualBind',
      showDuration: false,
    })
  // const bindMonthlyPolicy = () => setPopup({open: true, title:'Quote / Bind Coverage', body: 'Insert the insured\'s email', showDuration: true, duration: "monthlyBind"})
  const gotoFileAClaim = () =>
    setPopup({ open: true, title: "File a client's claim", body: "Insert the insured's email", action: 'fileAClaim' })
  const gotoUserMvrRecord = () =>
    setPopup({ open: true, title: 'View & Manage LexisNexis Reports', body: "Insert the customer's email", action: 'mvr' })

  const isAdmin = SessionService.isAdmin()
  return (
    <Container maxWidth="sm">
      <br />
      <div className="text-promotion black bolder textcenter margin-top-medium">{isAdmin ? 'Admin' : 'Broker'} Portal</div>
      <br />
      <div className="text-body black textcenter light">Hello, </div>
      <div className="text-body black bold textcenter margin-top-small margin-bottom-basic">What would you like to do?</div>
      <br />

      <Grid container spacing={4}>
        <Grid xs={12} sm={12} md={6}>
          <SkyPaper className={classNames('margin-top-medium card-style')}>
            <FlexView hAlignContent={'center'}>
              <AccountSvg className="large-icon lightgrayblue-stroke-svg" />
            </FlexView>
            <div className="text-body lightgrayblue bold textcenter margin-top-6 ">Quote New Customer</div>
            <Divider />
            {FirebaseService.getBoolean(FirebaseConfigKey.ANNUAL_AVAILABLE) && (
              <div onClick={bindAnnualPolicy} className="text-small textcenter black clickable margin-top-large margin-botoom-medium">
                Annual Coverage
              </div>
            )}
          </SkyPaper>
        </Grid>
        <Grid xs={12} sm={12} md={6}>
          <SkyPaper className="margin-top-medium card-style">
            <FlexView hAlignContent={'center'}>
              <AccountSvg className="large-icon lightgrayblue-stroke-svg" />
            </FlexView>
            <div className="text-body lightgrayblue bold textcenter margin-top-6 ">Manage Accounts</div>
            <Divider />
            {isAdmin ? (
              <div>
                <div onClick={gotoPolicyManagement} className="text-small textcenter black clickable">
                  Manage Policies
                </div>
                <div onClick={gotoInsuredAccount} className="text-small textcenter margin-top-small black clickable">
                  Manage Profile
                </div>
              </div>
            ) : (
              <div>
                <div onClick={gotoRecentSubmissions} className="text-small textcenter black clickable">
                  Recent Submissions
                </div>
                <div onClick={gotoAccounts} className="text-small textcenter margin-top-small black clickable">
                  Active Accounts
                </div>
              </div>
            )}
          </SkyPaper>
        </Grid>
        <Grid xs={12} sm={12} md={6}>
          {BrokerConfigService.isSkywatchBroker() && isAdmin && (
            <SkyPaper className="margin-top-medium card-style">
              <FlexView hAlignContent={'center'}>
                <EqualizerIcon fontSize="large" className="large-icon lightgrayblue" />
              </FlexView>
              <div className="text-body lightgrayblue bold textcenter margin-top-6 ">Voom Dashboard</div>
              <Divider />
              <div onClick={openDashboard} className="text-small textcenter black clickable margin-botoom-6">
                View Dashboard
              </div>
            </SkyPaper>
          )}
        </Grid>
        <Grid xs={12} sm={12} md={6}>
          {isAdmin && (
            <SkyPaper className="margin-top-medium card-style">
              <FlexView hAlignContent={'center'}>
                <AccountSvg className="large-icon lightgrayblue-stroke-svg" />
              </FlexView>
              <div className="text-body lightgrayblue bold textcenter margin-top-6 ">Manage Motorcycles</div>
              <Divider />
              {
                <div>
                  <div onClick={addMotorcycle} className="text-small textcenter black clickable">
                    Add Motorcycles To DB
                  </div>
                </div>
              }
            </SkyPaper>
          )}
        </Grid>
        <Grid xs={12} sm={12} md={6}>
          {isAdmin && (
            <SkyPaper className="margin-top-medium card-style">
              <FlexView hAlignContent={'center'}>
                <AccountSvg className="large-icon lightgrayblue-stroke-svg" />
              </FlexView>
              <div className="text-body lightgrayblue bold textcenter margin-top-6 ">Admin</div>
              <Divider />
              <div onClick={() => history.push('/broker/admin/agencies')} className="text-small textcenter black clickable">
                Agencies
              </div>
              <div onClick={() => history.push('/broker/admin/bordereaux')} className="text-small textcenter black clickable">
                Bordereaux
              </div>{' '}
              <div onClick={() => history.push('/broker/admin/bookrollover')} className="text-small textcenter black clickable">
                Book Rollover
              </div>
            </SkyPaper>
          )}
        </Grid>
        <Grid xs={12} sm={12} md={6}>
          {BrokerConfigService.isSkywatchBroker() && isAdmin && (
            <SkyPaper className="margin-top-medium card-style">
              <FlexView hAlignContent={'center'}>
                <ErrorDocument className="large-icon lightgrayblue-stroke-svg" />
              </FlexView>
              <div className="text-body lightgrayblue bold textcenter margin-top-6 ">MVR Reports</div>
              <Divider />
              <div onClick={gotoUserMvrRecord} className="text-small textcenter black clickable margin-botoom-6">
                View & Manage LexisNexis response
              </div>
            </SkyPaper>
          )}
        </Grid>
        <Grid xs={12} sm={12} md={6}>
          {FirebaseService.getBoolean(FirebaseConfigKey.PROPOSAL_LINK_AVAILABLE) && (
            <SkyPaper className="margin-top-medium card-style">
              <FlexView hAlignContent={'center'}>
                <ShareIcon fontSize="large" className="large-icon lightgrayblue" />
              </FlexView>
              <div className="text-body lightgrayblue bold textcenter margin-top-6 ">Share</div>
              <Divider />
              <div onClick={shareProporsalLink} className="text-small textcenter black clickable">
                Share Proposal Link
              </div>
            </SkyPaper>
          )}
        </Grid>

        {/* <Grid item xs={12} sm={12} md={6}>
                    <SkyPaper className="margin-top-medium card-style">
                        <FlexView hAlignContent={'center'}>
                            <AccountSvg className="large-icon lightgrayblue-stroke-svg" />
                        </FlexView>
                        <div className="text-body lightgrayblue bold textcenter margin-top-6">Customers Management</div>
                        <Divider />
                        <div className="text-small textcenter black clickable">Manage Insured's Policies</div>
                        <div className="text-small textcenter black clickable margin-top-small">Manage Insured's Profile</div>
                        <div className="text-small textcenter black clickable margin-top-small">Manage Insured's Credit Card</div>
                        <div className="text-small textcenter black clickable margin-top-small">Redeem Insured's Code</div>
                    </SkyPaper>
                </Grid> */}
      </Grid>

      <GetImpersonationPopup
        onCancel={cancelPopup}
        showDuration={popup.showDuration}
        duration={popup.duration}
        open={popup.open}
        title={popup.title}
        body={popup.body}
        onConfirm={onConfirm}
      />

      <GetEmailPopup
        onCancel={cancelPopup}
        showDuration={emailPopup.showDuration}
        duration={emailPopup.duration}
        open={emailPopup.open}
        title={emailPopup.title}
        body={emailPopup.body}
        onConfirm={onConfirm}
      />

      <AddMotorcyclesPopup
        onCancel={cancelMotorcyclePopup}
        showDuration={motorcyclePopup.showDuration}
        duration={motorcyclePopup.duration}
        open={motorcyclePopup.open}
        title={motorcyclePopup.title}
        body={motorcyclePopup.body}
        onConfirm={onConfirmMotorcycle}
      />
      <CustomErrorPopup
        title={popUpErrorState.title}
        body={popUpErrorState.body}
        open={popUpErrorState.showPopUp}
        onCancel={cancelErrorPopup}
      />
    </Container>
  )
}
